import { render } from "./TankManagement.vue?vue&type=template&id=3d84adda"
import script from "./TankManagement.vue?vue&type=script&lang=js"
export * from "./TankManagement.vue?vue&type=script&lang=js"

import "./TankManagement.vue?vue&type=style&index=0&id=3d84adda&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__